import React, { useState, useEffect, useMemo, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { ContentsItem } from '../../../modules/editor/types';
import { RootState } from '../../../modules';
import MapToolbar from '../Toolbar/MapToolbar';
import { editContent } from '../../../modules/editor';

type Props = {
	contentItem: ContentsItem
};

function Map({ contentItem }: Props) {
	const dispatch = useDispatch();
	const [isDummy, setIsDummy] = useState(false);
	const [showToolbar, setShowToolbar] = useState(false);
	const [linkModalOpen, setLinkModalOpen] = useState(false);
	const contentId = useMemo(() => contentItem.id, [contentItem.id]);

	const { selectedContentId, prevSelectedContentId } = useSelector(({ editor: { selectedContentId, prevSelectedContentId }}: RootState) => ({ selectedContentId, prevSelectedContentId }));
	const contentBeforeSave = useRef(contentItem.content.content[0]);
	
	useEffect(() => {
		if (selectedContentId !== contentId) {
			unselectContent();
		}
		if (prevSelectedContentId === contentId) {
			const needsToSave = Object.keys(contentBeforeSave.current).some((key) => {
				const before = contentBeforeSave.current[key];
				const after = contentItem.content.content[0][key];
				return before !== after;
			});
			if (needsToSave) {
				dispatch(editContent({ target: `${contentId}/content/0/imageAlt`, data: contentItem.content.content[0].imageAlt, mode: 'force' }));
			}
			contentBeforeSave.current = contentItem.content.content[0];
		}
	}, [selectedContentId]);

	useEffect(() => {		
		setIsDummy(contentItem?.content.content[0]?.imagePath?.includes('dummy') || false);
	}, [contentItem])

	const startEditing = () => {
		setShowToolbar(true);
	}

	const unselectContent = () => {
		setShowToolbar(false);
		setLinkModalOpen(false)
	}

	const openLinkModal = () => {		
		startEditing();
		setTimeout(() => {			
			setLinkModalOpen(true);
		}, 10);
	}

	return (
		<div
			className="map-edit"
		>
			<div className="map-edit-content">
				<img src={contentItem?.content.content[0].imagePath} alt={contentItem?.content.content[0].imageAlt} />
				{
					contentItem?.content?.content[0]?.imagePath?.includes('dummy_map') && (
						<p className="dummy-text">핀 버튼을 눌러 주소를 입력하세요</p>
					)					
				}
			</div>
			{
				showToolbar ? (
					<MapToolbar
						innerContent={contentItem.content.content[0]}
						style={contentItem.content.style[0].partition}
						contentId={contentItem.id}
						contentIndex={0}
						isLinkModalOpen={linkModalOpen}
					/>
				) : (
					<>
						{
							isDummy ? (
								<div
									className="cover"
									onClick={openLinkModal}
								>
								</div>
							) : (
								<div
									className="cover"
									onClick={startEditing}
								>
								</div>
							)
						}
					</>
				)
			}
		</div>
	)
}

export default Map;